export const analytics = {
  track: ['id']
}
